import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { NotificationProvider } from './contexts/NotificationContext';
import { HelmetProvider } from 'react-helmet-async';

// Landing Page
import LandingPage from './pages/landing/LandingPage';

// App Routes
import AppRoutes from './routes/AppRoutes';

// 404 Page
import NotFound from './pages/NotFound';

function App() {
  return (
    <HelmetProvider>
      <NotificationProvider>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            {/* Landing Page */}
            <Route path="/" element={<LandingPage />} />
            
            {/* Application Routes */}
            <Route path="/app/*" element={<AppRoutes />} />
            
            {/* 404 - Catch all unmatched routes */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </NotificationProvider>
    </HelmetProvider>
  );
}

export default App;
